var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/search",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33337 2.66659C4.75605 2.66659 2.66671 4.75592 2.66671 7.33325C2.66671 9.91058 4.75605 11.9999 7.33337 11.9999C9.9107 11.9999 12 9.91058 12 7.33325C12 4.75592 9.9107 2.66659 7.33337 2.66659ZM1.33337 7.33325C1.33337 4.01954 4.01967 1.33325 7.33337 1.33325C10.6471 1.33325 13.3334 4.01954 13.3334 7.33325C13.3334 10.647 10.6471 13.3333 7.33337 13.3333C4.01967 13.3333 1.33337 10.647 1.33337 7.33325Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6286 10.6286C10.889 10.3683 11.3111 10.3683 11.5714 10.6286L14.4714 13.5286C14.7318 13.789 14.7318 14.2111 14.4714 14.4714C14.2111 14.7318 13.789 14.7318 13.5286 14.4714L10.6286 11.5714C10.3683 11.3111 10.3683 10.889 10.6286 10.6286Z",
    fill: "#171717"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b77cdb9014060caed8cc20508f5d1b92.svg";
export { ForwardRef as ReactComponent };